import React from 'react';
const sizeToString = (x) => typeof x === 'number' ? `${x}px` : x;
const buildMediaQuery = (xs) => xs.map((x) => `(${x[0]}:${sizeToString(x[1])})`).join(' and ');
export const useMediaQuery = (...input) => {
    const query = React.useMemo(() => buildMediaQuery(input), [input]);
    const getMatches = typeof window === 'undefined' ? (_) => false : (query) => window.matchMedia(query).matches;
    const [matches, setMatches] = React.useState(getMatches(query));
    React.useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const listener = (e) => {
            setMatches(e.matches);
        };
        mediaQueryList.addEventListener('change', listener);
        setMatches(mediaQueryList.matches);
        return () => mediaQueryList.removeEventListener('change', listener);
    }, [query]);
    return matches;
};
